module.exports = __webpack_public_path__ + "img/l.22eff1e2.webp";